import Axios from 'axios'

import { validCodes } from '../constants'
import { token } from './token'

export const baseService = {
  get,
  put,
  post,
  delete: _delete,
}

// enhanced timeout for big providers response
const axios = Axios.create({
  timeout: 300000,
})

//= ==========CRUD Operations=====================//

// Get Call
function get(url, header, params = {}) {
  return axios
    .get(url, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json',
        Authorization: `Bearer ${header}`,
      },
      params
    })
    .then(handleResponse)
    .catch(error)
}

// create Call
function put(url, header, body) {
  return axios
    .put(url, body, { headers: { Authorization: header.Authorization } })
    .then(handleResponse)
    .catch(error)
}
// update Call
function post(url, body, header) {
  if (header) {
    return axios
      .post(url, body, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          Accept: 'application/json',
          Authorization: `Bearer ${header}`,
        },
      })
      .then(handleResponse)
      .catch(error)
  }
  return axios
    .post(url, body, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json',
      },
    })
    .then(handleResponse)
    .catch(error)
}

// Delete Call (prefixed function name with underscore because delete is a reserved word in javascript)
function _delete(url, header, params) {
  return axios
    .delete(url, { headers: { Authorization: header.Authorization } })
    .then(handleResponse)
    .catch(error)
}

// callback of response (returns promise)
function handleResponse(response) {
  if (!validCodes(response.status)) {
    return Promise.reject(response)
  }
  response &&
    response.data &&
    response.data.sessionToken &&
    token.setToken(response.data.sessionToken)
  return response
}

// callback of error
function error(error) {
  const responseUrl = error.request.responseURL ? error.request.responseURL : ''

  // in case of s3 cached response signed redirect failed due to auth token header. do again!
  if (
    error.response.status === 400 &&
    responseUrl.includes('s3.amazonaws.com')
  ) {
    return axios.get(responseUrl)
  }

  // should throw? what if something expects the return...
  return error
}
